<form [formGroup]="form" class="row">
  <div class="col">
    <div
      #addressListContainer
      formArrayName="ipv4"
      class="d-flex flex-column gap-1 overflow-y-auto address-list-container"
    >
      @if (formArray.length) {
        @for (control of formArray.controls; let i = $index; track $index) {
          <div class="d-flex align-items-start gap-1">
            <app-form-control-ipv4
              #ipv4El
              [formControlName]="i"
              class="flex-grow-1"
              (keyUp.enter)="appendControl()"
              (keyUp.control.delete)="removeControl(i)"
            ></app-form-control-ipv4>
            <button type="button" class="btn text-body-secondary" (click)="removeControl(i)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        }
      } @else {
        <h5 class="text-center text-body-secondary my-3">
          No device IP addresses have been added yet.<br /><span class="fw-normal" style="font-size: small"
            >Click the button below to add one.</span
          >
        </h5>
      }
    </div>
    <button type="button" class="btn btn-outline-secondary mt-1 w-100 add-ip-input" (click)="appendControl()">
      <i class="bi bi-plus-lg me-1"></i>
      ADD IP ADDRESS
    </button>
  </div>
</form>
